import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
let DataAnalyseService = class DataAnalyseService {
    constructor(dataAnalysisApi) {
        this.dataAnalysisApi = dataAnalysisApi;
    }
};
DataAnalyseService = __decorate([
    injectable(),
    __param(0, inject(Symbols.DataAnalysisApi)),
    __metadata("design:paramtypes", [Object])
], DataAnalyseService);
export { DataAnalyseService };
